import React, { useState } from 'react';
import II18 from '../translate/II18';
import {
  Block,
  Button,
  List,
  ListInput,
  ListItemRow,
  f7
} from 'framework7-react';
import PaperflyAPI from '../../server/api/PaperflyAPI';
import PropTypes from 'prop-types';
import { emailIsValid, userEmailOrMobileIsValid } from '../helpers/utils';

export default function EnterEmailForm(props) {
  const [userEmail, setUserEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const smsDisabled = true;

  const emailNotValid =
    userEmail && !userEmailOrMobileIsValid(userEmail, smsDisabled);

  const userDataOk = userEmailOrMobileIsValid(userEmail, smsDisabled);

  const onClick = () => {
    PaperflyAPI.registerEmail(props.recipientRequestId, userEmail).then(
      () => setEmailSent(true),
      error => f7.dialog.alert(II18.get('technical_error'))
    );
  };

  return (
    <div
      style={{
        paddingBottom: 80,
        paddingTop: 10
      }}
    >
      {emailSent ? (
        <Block>
          <p style={{ padding: '0 10px', textAlign: 'center' }}>
            {II18.get(
              'post_request_save_email_success',
              II18.get(
                emailIsValid(userEmail)
                  ? 'post_request_email'
                  : 'post_request_sms'
              )
            )}
          </p>
        </Block>
      ) : (
        <div>
          <List
            noHairlines
            noHairlinesBetween
            style={{ width: '100%', margin: '10px 0' }}
          >
            <ListItemRow>
              <label
                style={{
                  textAlign: 'center',
                  display: 'block',
                  width: '100%',
                  padding: '0 10px'
                }}
              >
                {II18.get(
                  smsDisabled
                    ? 'post_request_save_email_only_message'
                    : 'post_request_save_email_message'
                )}
              </label>
            </ListItemRow>
            <ListInput
              id={'userEmail'}
              onInputClear={() => setUserEmail('')}
              outline
              floatingLabel
              errorMessageForce={emailNotValid}
              errorMessage={
                emailNotValid
                  ? II18.get(
                      smsDisabled
                        ? 'post_request_wrong_email_only'
                        : 'post_request_wrong_email_phone'
                    )
                  : null
              }
              required
              label={II18.get(
                smsDisabled
                  ? 'post_request_your_email_only_message'
                  : 'post_request_your_email_message'
              )}
              type="text"
              clearButton
              value={userEmail || ''}
              onChange={e => setUserEmail(e.target.value.trim())}
            />
          </List>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              marginTop: 30
            }}
          >
            <Button
              id={'sendDocumentsAndUserDataButton'}
              className={userDataOk ? 'active' : 'notactive'}
              popupClose
              color={userDataOk ? 'green' : 'gray'}
              raised
              fill
              disabled={!userDataOk}
              style={{
                maxWidth: 350,
                lineHeight: '48px',
                height: 48,
                fontSize: 16,
                padding: '0 30px',
                color: userDataOk ? 'white' : '#cfcfcf',
                backgroundColor: userDataOk ? 'green' : '#eae9e9',
                boxShadow: userDataOk ? {} : 'none'
              }}
              onClick={onClick}
            >
              <span>{II18.get('title_ok')}</span>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

EnterEmailForm.propTypes = {
  recipientRequestId: PropTypes.string
};
